import { createContext, ReactNode, useContext, useLayoutEffect } from 'react';

type AppShellHeaderAccessoryContextValue = {
  isAvailable: boolean;
  setHeaderAccessory: (accessory: ReactNode | null) => void;
};

export const AppShellHeaderAccessoryContext = createContext<AppShellHeaderAccessoryContextValue>({
  isAvailable: false,
  setHeaderAccessory: () => undefined,
});

export function useAppShellHeaderAccessory(accessory: ReactNode | null) {
  const { isAvailable, setHeaderAccessory } = useContext(AppShellHeaderAccessoryContext);

  useLayoutEffect(() => {
    setHeaderAccessory(accessory);

    return () => {
      setHeaderAccessory(null);
    };
  }, [accessory, setHeaderAccessory]);

  return isAvailable;
}
